<div>
  <div *ngIf="loading" class="loading-indicator">
    <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
  </div>
  <div class="msTeam-modalBodyScroll" *ngIf="!loading">
    <div *ngIf=isShare class="padleftright15">
      <sharesettings-dialog #shareSettingsDialog></sharesettings-dialog>
    </div>

    <mat-list role="list" class="sitelist" *ngIf=!isShare>
      <div class="nodata"
      *ngIf="(sites.length == 0 ||(sites | filter: searchText :['sitename']).length === 0) && !loading">
      <img src="assets/ic_no_data.svg" width="90" alt="" class="padbottom10" >
      <!-- <div class="nodata"></div> -->
      <!-- <div class="nodatatxt"> -->
        <div class="nodatatxt">
        {{noSites}}</div>  
    </div>
      <mat-list-item class="sitelistitem"
        *ngFor="let item of (sites | sortBy: 'sitename' | filter: searchText :['sitename']);last as last; let i = index"
        role="listitem"
        [ngStyle]="i==0 && !searchText? {'margin-bottom': '20px','height': '55px'} : {'height': '55px'}">
        <mat-divider *ngIf="i==0 && !searchText"> </mat-divider>
        <!-- <mat-divider [inset]="false" class="matlist-divider"  *ngIf="i==1"></mat-divider>  -->
        <mat-radio-button aria-label="Select site {{item.sitename}}" [value]="item"
        (change)="clickedRow($event.value)" (click)="clickedRow(item)">
        <!-- <mat-icon matListIcon style="width:15px;"> -->
          <!-- <div class="row"> -->
            <!-- <mat-radio-group [(ngModel)]="highlightRow" formControlName="radiooptions"> -->
              <!-- <mat-radio-button aria-label="Select {{item.sitename}}" [value]="item" color="primary"
                                (change)="clickedRow($event.value)" (click)="clickedRow(item)"></mat-radio-button> -->
            <!-- </mat-radio-group> -->
          <!-- </div> -->
        <!-- </mat-icon> -->
        <span style="margin-top: 10px;" tabindex="0" matLine  (keyup.enter)="getFolderInfo(item,false)" (click)="getFolderInfo(item,false)" class="span1" role="link" attr.aria-label="Open site {{item.sitename}}">
          <div class="siteIcon"></div>
          <span matTooltip={{item.sitename}} matLine class="span2" style="margin-left: 30px;margin-top: 3px;margin-right:15px;">{{item.sitename}}</span>    
          <!-- <span matTooltip={{item.sitename}} matLine  [innerHTML]="item.sitename | highlight: searchText" class="span2" style="margin-left: 30px;margin-top: 3px;"></span> -->
                     <!-- <div class="arrowIcon" style="float: right;"></div> -->
        <div (click)="getFolderInfo(item,false)" class="arrowIcon" style="margin-top: -13px"></div>

        <ng-template [ngIf]="item.isSyncable==0 && (item.siteRestrictionType.passwordprotected ==1 || item.siteRestrictionType.twoFactorAuthentication ==1 || item.siteRestrictionType.termsandconditions ==1 || item.siteRestrictionType.iprestrictedsite ==1)">
          <div class="lockIcon" style="margin-right: 10px;margin-top: -15px"></div>
        </ng-template>  
      </span>

        <mat-divider [inset]="false" class="matlist-divider" *ngIf="!last"></mat-divider> 
       
      </mat-radio-button>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="msTeam-modal-footer add-divider" *ngIf="!isShare && !loading">
    <button *ngIf="this.isButtonVisible" type="button" mat-raised-button class="msTeam-btn full-width"
      (click)="loadMore()">{{loadingMessage}}</button>
  </div>

  <div class="global-footer">
    <div class="error-msg" [innerHTML]="errorMsg.str" *ngIf="errorMsg.str.length >0 && !loading"></div>

    <div class="msTeam-modal-footer-right" *ngIf="!loading && isUpload">
      <button mat-raised-button (click)="closeMSTeamApp()" class="cancelBtn">Cancel</button>
      <button id="upload_btn" class="msTeam-btn" mat-raised-button [disabled]="sharebutton.isDisabled" style="margin-left:10px;"
        (click)="uploadItem()">
        {{uploadToHQ}}
      </button>
    </div>
    <div class="msTeam-modal-footer-right" *ngIf="!loading && !isUpload && !isShare">
      <button mat-raised-button style="margin-right:10px;" (click)="closeDialog()" class="cancelBtn">Cancel</button>
      <button id="share_btn" class="msTeam-btn" mat-raised-button [disabled]="sharebutton.isDisabled"  *ngIf="errorMsg.str.length ==0"
        (click)="shareItem()">{{sharebutton.sharetitle}}</button>

        <button id="share_btn" class="msTeam-btn" mat-raised-button [disabled]="sharebutton.isDisabled"  *ngIf="errorMsg.str.length > 0"
        (click)="shareItem()">{{sharebutton.sharetitledefault}}</button>
 

    </div>
  </div>
</div>